import React from 'react'
import PageTitle from '../components/PageTitle'
import Link from '../components/Link'
import Layout from '../components/Layout'

const OtherResources = () => (
  <Layout>
    <PageTitle name="Other Resources" site="OIRA" />
    {/* <h2 id="from-our-office">From Our Office</h2>
    <ul>
      <li>
        <Link to="http://oira.ua.edu/factbook">Factbook</Link>
      </li>
      <li>
        <Link to="http://syllabi.ua.edu">Syllabus Archive (pre-Summer 2023)</Link>
      </li>
      <li>
        <Link to="http://oira.ua.edu/new/soi">
          Student Opinions of Instruction
        </Link>
      </li>
      <li>
        <Link to="https://oie.ua.edu">
          Office of Institutional Effectiveness
        </Link>
      </li>
    </ul> */}
    <h2 id="the-university-of-alabama-system">
      The University of Alabama System
    </h2>
    <ul>
      <li>
        <Link to="http://www.uasystem.ua.edu/">
          The University of Alabama (UA) System
        </Link>

        <ul>
          <li>
            <Link to="http://uasystem.ua.edu/ua-system-office/organizational-chart/">
              UA System Organizational Chart
            </Link>
          </li>
          <li>
            <Link to="http://uasystem.ua.edu/board-of-trustees/">
              The Board of Trustees
            </Link>
          </li>
          <li>
            <Link to="http://uasystem.edu/about/mission-values-vision/">
              UA System Mission Statement
            </Link>
          </li>
        </ul>
      </li>
      <li>
        <Link to="http://www.ua.edu/">The University of Alabama</Link>
      </li>
      <li>
        <Link to="http://www.uab.edu/">
          The University of Alabama at Birmingham
        </Link>
      </li>
      <li>
        <Link to="http://www.uah.edu/">
          The University of Alabama in Huntsville
        </Link>
      </li>
    </ul>
    <h2 id="institutional-research">Institutional Research</h2>
    <ul>
      {/* <li>
        <Link to="http://oira.ua.edu/chime-in/">
          Chime In
        </Link>
      </li> */}
      <li>
        <Link to="http://www.airweb.org/">
          Association for Institutional Research (AIR)
        </Link>

        <ul>
          <li>
            <Link to="http://www.airweb.org/page.asp?page=309">
              IR Resources
            </Link>
          </li>
          <li>
            <Link to="http://eair.airweb.org/">E-Newsletter/News</Link>
          </li>
          <li>
            <Link to="http://www.airweb.org/?page=1156#professional">
              Professional Development
            </Link>
          </li>
          <li>
            <Link to="http://www.airweb.org/page.asp?page=5">Publications</Link>
          </li>
        </ul>
      </li>
      <li>
        <Link to="http://www.sair.org/">
          Southern Association for Institutional Research (SAIR)
        </Link>
      </li>
      <li>
        <Link to="http://www.alair.org/">
          Alabama Association for Institutional Research (ALAIR)
        </Link>
      </li>
    </ul>
    <h2 id="periodicals">Periodicals</h2>
    <ul>
      <li>
        <Link to="http://chronicle.com/">Chronicle of Higher Education</Link>
      </li>
      <li>
        <Link to="http://www.edweek.org/ew/index.html">Education Week</Link>
      </li>
    </ul>
    <h2 id="state-of-alabama">State of Alabama</h2>
    <ul>
      <li>
        <Link to="http://www.ache.state.al.us/">
          Alabama Commission for Higher Education (ACHE)
        </Link>
      </li>
      <li>
        <Link to="http://www.alabamacommunitiesofexcellence.org/alabama-department-of-postsecondary-education/">
          Alabama Department of PostSecondary Education (DPE)
        </Link>
      </li>
      <li>
        <Link to="http://www.alsde.edu/Pages/home.aspx">
          Alabama State Department of Education (ALSDE)
        </Link>
      </li>
    </ul>
    <h2 id="federal-government">Federal Government</h2>
    <ul>
      <li>
        <Link to="http://nces.ed.gov/">
          National Center for Educational Statistics (NCES)
        </Link>
      </li>
      <li>
        <Link to="http://nces.ed.gov/ipeds/">
          Integrated Postsecondary Education Data System (IPEDS)
        </Link>

        <ul>
          <li>
            <Link to="http://nces.ed.gov/ipedspas/">IPEDS Data Center</Link>
          </li>
          <li>
            <Link to="http://nces.ed.gov/pubsearch/getpubcats.asp?sid=010">
              IPEDS Publications
            </Link>
          </li>
        </ul>
      </li>
      <li>
        <Link to="http://www.ed.gov/">U.S. Department of Education</Link>
      </li>
      <li>
        <Link to="http://www.census.gov/">U.S. Census Bureau</Link>
      </li>
    </ul>
    <h2 id="higher-education">Higher Education</h2>
    <ul>
      <li>
        <Link to="http://agb.org/">
          Association of Governing Boards of Universities and Colleges (AGB)
        </Link>
      </li>
      <li>
        <Link to="http://chronicle.com/section/Facts-Figures/58/">
          The Chronicle of Higher Education: Facts &amp; Figures
        </Link>
      </li>
      <li>
        <Link to="http://www.ecs.org/">
          Education Commission of the States (ECS)
        </Link>
      </li>
      <li>
        <Link to="http://grapevine.illinoisstate.edu/">Grapevine</Link>
      </li>
      <li>
        <Link to="http://www.acenet.edu//AM/Template.cfm?Section=Home">
          American Council on Education (ACE)
        </Link>
      </li>
      <li>
        <Link to="http://www.ihep.org/">
          The Institute for Higher Education Policy (IHEP)
        </Link>
      </li>
      <li>
        <Link to="http://nces.ed.gov/ipeds/research/">
          National Postsecondary Education Cooperative (NPEC)
        </Link>
      </li>
      <li>
        <Link to="http://www.sacscoc.org/">
          Southern Association of Colleges and Schools (SACS)
        </Link>
      </li>
      <li>
        <Link to="http://www.scup.org/">
          Society for College and University Planning (SCUP)
        </Link>
      </li>
      <li>
        <Link to="http://www.sheeo.org/">
          State Higher Education Executive Officers (SHEEO)
        </Link>
      </li>
      <li>
        <Link to="http://www.sreb.org/">
          Southern Regional Education Board (SREB)
        </Link>
      </li>
    </ul>
  </Layout>
)

export default OtherResources
